export default [
  {
    path: '',
    // Relative to /src/views
    view: 'Index',
    name: 'Index',
    meta: {
      authRequired: false
    }
  },
  {
    path: '/entreprisenewmat',
    view: 'Entreprise',
    name: 'Entreprise',
    meta: {
      authRequired: false
    }
  },
  {
    path: '/equipenewmat',
    view: 'Equipe',
    name: 'Equipe',
    meta: {
      authRequired: false
    }
  },
  {
    path: '/partenairenewmat',
    view: 'Partenaire',
    name: 'Partenaire',
    meta: {
      authRequired: false
    }
  },
  {
    path: '/localisationnewmat',
    view: 'Localisation',
    name: 'Localisation',
    meta: {
      authRequired: false
    }
  },
  {
    path: '/prestationsnewmat',
    view: 'Prestations',
    name: 'Prestations',
    meta: {
      authRequired: false
    }
  },
  {
    path: '/aspectnewmat',
    view: 'Aspect',
    name: 'Aspect',
    meta: {
      authRequired: false
    }
  },
  {
    path: '#services',
    name: 'Services',
    meta: {
      authRequired: false
    }
  },
  {
    path: '/connexion',
    view: 'Connexion',
    meta: {
      authRequired: false
    }
  },
  {
    path: '/admin',
    // Relative to /src/views
    view: 'Administration',
    name: 'Administration',
    meta: {
      authRequired: true
    }
  },
  {
    path: '/actualites',
    name: 'Actualites',
    view: 'Actualites',
    meta: {
      authRequired: true
    }
  },
  {
    path: '/devis',
    name: 'Devis',
    view: 'Devis',
    meta: {
      authRequired: true
    }
  },
  {
    path: '/realisations',
    name: 'Realisations',
    view: 'Realisations',
    meta: {
      authRequired: true
    }
  }
]
